// Form panels: .contact-form-wrapper (contact form block) and
// .partner-form-wrapper (full image/video and three-col feature blocks).
const panelSelector = ".contact-form-wrapper, .partner-form-wrapper";
const containerSelector = ".contact-form-container, .partner-form-container";
const panels = document.querySelectorAll(panelSelector);
const formButtons = document.querySelectorAll(".partner-button");
const body = document.querySelector("body");

function findPanel(button) {
	// A button in a block with its own panel opens that panel
	const section = button.closest("section");
	const sectionPanel = section && section.querySelector(panelSelector);
	if (sectionPanel) {
		return sectionPanel;
	}

	// Other buttons (header, submenu) open the contact form shown for the
	// visitor's country, then any panel on the page
	return document.querySelector(".contact-form-wrapper.show-block")
		|| document.querySelector(".contact-form-wrapper")
		|| document.querySelector(".partner-form-wrapper");
}

if (panels.length > 0) {
	formButtons.forEach(button => {
		button.addEventListener("click", function(e) {
			const panel = findPanel(button);
			if (!panel) {
				return;
			}
			const formContainer = panel.querySelector(containerSelector);

			panel.classList.add("display");
			setTimeout(function() {
				panel.classList.add("active");
				formContainer.classList.add("active");
				body.style.overflow = "hidden";
			}, 1);
		});
	});

	// Handle exit events
	panels.forEach(panel => {
		const exitElements = panel.querySelectorAll(".backdrop, .form-exit");
		const formContainer = panel.querySelector(containerSelector);

		exitElements.forEach(element => {
			element.addEventListener("click", function(e) {
				body.style.overflow = "visible";
				panel.classList.remove("active");
				formContainer.classList.remove("active");
				setTimeout(function() {
					panel.classList.remove("display");
				}, 300);
			});
		});
	});
}
